import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { removeNodeEpic } from './_epics/removeNode.epic';
import { loadNodeListEpic } from './_epics/loadNodeList.epic';

export const nodeEpic = safeCombineEpics(
  removeNodeEpic,
  loadNodeListEpic,
);
